import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import SessionContext from '../../contexts/SessionContext';

export interface SessionCheckProps{
    shouldRedirect?: boolean;
}

// AuthProvider marks the session expired when /api/Account/me's expiresAt
// passes; this sends the user home from pages that need a session.
const SessionCheck: React.FC<SessionCheckProps> = ({ shouldRedirect })=>{

    const history = useHistory();
    const { isExpired } = useContext(SessionContext)

    React.useEffect(()=>{
        if (isExpired && shouldRedirect) {
            history.push('/');
        }
    }, [isExpired, shouldRedirect, history])

    return null
}

export default SessionCheck;
